export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()

  if (process.env.NODE_ENV === 'production') {
    const { clientId, bucketName } = config.public
    const url = `https://storage.googleapis.com/${bucketName}/site_resources/${clientId}/target/target.json`
    const cdnTester = new CdnTester(url, clientId)

    // 背景測線：先使用 .env 預設的 CDN，測線完成後再替換為最快的 CDN
    cdnTester.test().then((cdnUrl) => {
      config.public.cdn = cdnUrl
      console.info(`[CDN] Production CDN URL set to: ${cdnUrl}`)
    })
  }
})

class CdnTester {
  constructor(url, clientId) {
    this.url = url
    this.cdn = []
    this.clientId = clientId
  }

  async init() {
    const target = await fetch(this.url)
    const { cdn } = await target.json()
    this.cdn = cdn
  }

  async test() {
    try {
      if (this.cdn.length === 0) {
        await this.init()
      }
      const { url, index } = await Promise.any(
        this.cdn.map((url, i) => {
          return this.ping(url, i)
        })
      )
      console.info(`[Network] CDN ${index} is chosen. (${url})`)
      return url
    } catch (error) {
      console.error('[Network] Network Test Fail.', error)
      return process.env.CDN
    }
  }

  async ping(url, index) {
    let ts, response
    try {
      ts = new Date().getTime()
      response = await fetch(`${url}/site_resources/${this.clientId}/target/test.png?${ts}`)
      return { url, index }
    } finally {
      const speed = new Date().getTime() - ts
      const status = response?.ok ? 'Success' : 'Failure'
      console.info(`[Network] CDN: ${index}, URL: ${url}, Status: ${status}, Speed: ${speed}ms`)
    }
  }
}
